module.exports = __webpack_public_path__ + "assets/ic_volume_on.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/video/ic_volume_on.svg
// module id = 452
// module chunks = 19